import React, { memo, forwardRef } from "react";
const SvgCapitalXi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M10.972 24.136a.972.972 0 010-1.944h10.152a.972.972 0 010 1.944H10.972zm1.44-7.992a.972.972 0 010-1.944h7.272a.972.972 0 010 1.944h-7.272zm-.96-7.2a.972.972 0 010-1.944h9.192a.972.972 0 010 1.944h-9.192z"
      />
    </svg>
  );
});
SvgCapitalXi.displayName = "SvgCapitalXi";
const MemoForwardRef = memo(SvgCapitalXi);
export default MemoForwardRef;
